import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-white w-full min-h-screen flex flex-col items-center justify-center px-5 py-12">
      <div className="flex flex-col items-center justify-center gap-6 md:gap-7 lg:gap-8 flex-1">
        <div className="mb-8 md:mb-12 lg:mb-16">
          <Link to="/" className="inline-block">
            <div className="w-[180px] md:w-[280px] lg:w-[369px] h-[48px] md:h-[72px] lg:h-[98px] bg-[url('/logo.svg')] bg-contain bg-no-repeat bg-center" />
          </Link>
        </div>
        <h1 className="text-[#363636] text-[64px] md:text-[80px] lg:text-[96px] font-bold font-['Inter'] leading-[53px] md:leading-[67px] lg:leading-[80px] text-center">
          404
        </h1>

        <h2 className="text-[#851A1A] text-[28px] md:text-[40px] lg:text-[54px] font-normal font-['Inter'] leading-[41px] md:leading-[59px] lg:leading-[80px] text-center px-4">
          {t("notFound.title")}
        </h2>

        <div className="mt-4 md:mt-6 lg:mt-8">
          <Link
            to="/"
            className="w-[286px] md:max-w-[340px] lg:w-[400px] h-[60px] md:h-[75px] lg:h-[85px] bg-red-900 text-[#FCFCFC] text-[18px] md:text-[20px] lg:text-[24px] font-medium font-['Inter'] leading-[22px] md:leading-[24px] lg:leading-[29px] tracking-[-0.02em] transition-opacity duration-300 flex items-center justify-center hover:opacity-90 cursor-pointer"
          >
            {t("notFound.backToHome")}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
